
<div *ngIf="featured.length" class="container-fluid">
  <div class="feature-skills ion-text-center ion-no-padding">
    <h2 class="heading">Featured Skills</h2>
    <div class="feature-skills-slider">
      <div *ngFor="let feature of featured" class="feature-skills-item">
        <a *ngIf="slug=='global'" href="{{feature.url}}">
          <picture>
            <source srcset="/assets/images/internal/{{feature.image}}-services-{{feature.industry}}-country.webp" media="(min-width: 600px)" type="image/webp">
            <source srcset="/assets/images/internal/{{feature.image}}-services-{{feature.industry}}-country.jpg" media="(min-width: 600px)" type="image/jpeg">
            <source srcset="/assets/images/internal/{{feature.image}}-services-{{feature.industry}}-country-mobile.webp" type="image/webp">
            <source srcset="/assets/images/internal/{{feature.image}}-services-{{feature.industry}}-country-mobile.jpg" type="image/jpeg">
            <img src="/assets/images/internal/{{feature.image}}-services-{{feature.industry}}-country.jpg" alt="{{feature.name}}" loading="lazy" width="900" height="600">
          </picture>
          <div class="title">{{feature.name}}</div>
        </a>
        <a *ngIf="slug!=='global'" href="{{feature.url}}">
          <picture>
            <source srcset="/assets/images/internal/{{feature.image}}-services-{{feature.industry}}-region.webp" media="(min-width: 600px)" type="image/webp">
            <source srcset="/assets/images/internal/{{feature.image}}-services-{{feature.industry}}-region.jpg" media="(min-width: 600px)" type="image/jpeg">
            <source srcset="/assets/images/internal/{{feature.image}}-services-{{feature.industry}}-region-mobile.webp" type="image/webp">
            <source srcset="/assets/images/internal/{{feature.image}}-services-{{feature.industry}}-region-mobile.jpg" type="image/jpeg">
            <img src="/assets/images/internal/{{feature.image}}-services-{{feature.industry}}-region.jpg" alt="{{feature.name}}" loading="lazy" width="900" height="600">
          </picture>
          <div class="title">{{feature.name}}</div>
        </a>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid">
  <div class="all-skills">
    <h3 class="heading ion-padding-bottom"><a href="{{link}}">Find {{industry}} {{service}} in {{country}}</a></h3>
    <div class="row ion-padding-top">
      <div *ngFor="let skill of skills" class="col col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-2">
        <a *ngIf="slug=='global'" href="{{skill.url}}">
          <small>{{skill.name}}</small>
        </a>
        <a *ngIf="slug!=='global'" href="{{skill.url}}">
          <small>{{skill.name}}</small>
        </a>
      </div>
    </div>
  </div>
</div>
